import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'CmgMealBuilderItemSelectorCardCustomizationButton',
})
export default class CmgMealBuilderItemSelectorCardCustomizationButton extends Vue {
  @Prop({ default: false, type: Boolean })
  selected!: boolean;
}
